"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isDDDValid() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!value) return new classes_1.ValidationResult(true);
  var onlyNums = String(value.match(/\d+/g) || '');
  var phoneCode = onlyNums && typeof onlyNums === 'string' ? onlyNums.substring(0, 2) : '';
  var validPhoneCodeRegex = new RegExp('(11|12|13|14|15|16|17|18|19|21|22|24|27|28|31|32|33|34|35|37|38|41|42|43|44|45|46|47|48|49|51|53|54|55|61|62|63|64|65|66|67|68|69|71|73|74|75|77|79|81|82|83|84|85|86|87|88|89|91|92|93|94|95|96|97|98|99)', 'gi');
  var isValid = validPhoneCodeRegex.test(phoneCode);
  var message = isValid ? '' : "DDD ".concat(value, " n\xE3o \xE9 v\xE1lido");
  return new classes_1.ValidationResult(isValid, message);
}
exports.default = new classes_1.Validator(isDDDValid);